import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import { Button } from "@/components/ui/button"
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
    DropdownMenuSub,
    DropdownMenuSubContent,
    DropdownMenuSubTrigger,
} from "@/components/ui/dropdown-menu"
import { MoreHorizontal, Edit, Trash2, Eye, Package, Group, FacebookIcon } from "lucide-react"
import { FbPage } from "@/types/fb-type"
import exp from "constants"
import { useState } from "react"

interface FbPageCardProps {
    facebeookPage: FbPage,
    onConnect: (pageId: string) => void
}

export function FacebookPageCard(
    { facebeookPage, onConnect }: FbPageCardProps
) {
    const [loading, setLoading] = useState(false);

    const handleConnect = async () => {
        try {
            setLoading(true);
            await onConnect(facebeookPage.pageId);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Card className="group hover:shadow-md transition-shadow">
            <CardHeader className="pb-3">
                <div className="flex items-start justify-between">
                    <div className="flex-1">
                        <CardTitle className="text-lg line-clamp-1">{facebeookPage.pageName}</CardTitle>
                        <CardDescription className="line-clamp-2">
                            {facebeookPage.connectedBy || "No connected yet"}
                        </CardDescription>
                    </div>
                    <div>
                        <Button
                            type="button"
                            onClick={handleConnect}
                            disabled={loading}
                            className="w-full flex items-center justify-center gap-2 py-2 px-4 rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            {loading ? (
                                <>
                                    <svg
                                        className="animate-spin h-4 w-4 text-white"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                    >
                                        <circle
                                            className="opacity-25"
                                            cx="12"
                                            cy="12"
                                            r="10"
                                            stroke="currentColor"
                                            strokeWidth="4"
                                        ></circle>
                                        <path
                                            className="opacity-75"
                                            fill="currentColor"
                                            d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                                        ></path>
                                    </svg>
                                    <span>Connecting...</span>
                                </>
                            ) : (
                                <>
                                    <FacebookIcon /> Connect Now
                                </>
                            )}
                        </Button>
                    </div>

                </div>
            </CardHeader>

        </Card>
    )
}
